<div class="header-alert header-alert__{{data.type}}">
  <div class="container">
    <svg-icon *ngIf="data.type === 'error'" name="info-icon" fill="none"></svg-icon>
    <p class="header-alert__text"> <span [innerHtml]="data.message"></span>  <ng-container *ngIf="data.link" > Click <a [routerLink]="data.link">here</a> for more details.</ng-container> </p>
  </div>
</div>
